import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize, Observable, switchMap, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CAPTCHA_BACKEND_URL, FriendlyCaptchaService } from '../../common/friendly-captcha.service';

@Injectable()
export class CaptchaInterceptor implements HttpInterceptor {
  constructor(
    private captchaService: FriendlyCaptchaService,
    private spinnerService: NgxSpinnerService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.spinnerService.show();
    let httpEvent$ = next.handle(req);
    if (['POST', 'PUT'].includes(req.method) && this.captchaService.isCaptchaEnabled && req.url !== CAPTCHA_BACKEND_URL) {
      const solution = this.captchaService.friendlyCaptchaSolution;
      if (solution) {
        httpEvent$ = this._addCaptchaSolutionHeader(req, next, this.captchaService.friendlyCaptchaSolution.solution);
      } else {
        httpEvent$ = this._getNewSolutionAndRetry(req, next);
      }
    }

    return this._handleErrorsAndFinalize(req, next, httpEvent$);
  }

  private _handleErrorsAndFinalize(req: HttpRequest<any>, next: HttpHandler, httpEvent$:  Observable<HttpEvent<any>>): Observable<HttpEvent<any>> {
    return httpEvent$
    .pipe(
      catchError(error => {
        const captchaInHeaderWasInvalid = error.status === 406 && req.url !== CAPTCHA_BACKEND_URL;
        if (captchaInHeaderWasInvalid) {
          return this._getNewSolutionAndRetry(req, next);
        }
        return throwError(() => error);
      }),
      finalize(() => this.spinnerService.hide())
    );
  }

  private _addCaptchaSolutionHeader(req: HttpRequest<any>, next: HttpHandler, solution: string) {
    return next.handle(req.clone({
      setHeaders: {
        'X-Captcha-Solution': solution
      }
    }));
  }

  private _getNewSolutionAndRetry(req: HttpRequest<any>, next: HttpHandler) {
    return this.captchaService.getSolution()
    .pipe(switchMap(newSolution => {
      return this._addCaptchaSolutionHeader(req, next, newSolution.solution);
    }));
  }
}
